"use client";

import Link from "@/components/ui/CcLink";

import { CcEyebrow } from "@/components/ui/CcEyebrow";
import { CcHubSpotIcon } from "@/components/ui/CcHubSpotIcon";

type CcHeroAnnouncementProps = {
  label: string;
  text: string;
  href: string;
};

export function CcHeroAnnouncement({ label, text, href }: CcHeroAnnouncementProps) {
  const accessibleLabel = `${label}: ${text}`;

  return (
    <Link
      href={href}
      className="cc-hero__announcement"
      aria-label={accessibleLabel}
    >
      <CcEyebrow
        as="span"
        theme="on-subtle"
        className="cc-hero__announcement-eyebrow"
        accentCharCount={label.length}
        prefix={
          <span className="cc-hero__announcement-icon">
            <CcHubSpotIcon size={16} />
          </span>
        }
        suffix={
          <span className="cc-hero__announcement-chevron">
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 1L5 5L1 9"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        }
      >
        {`${label} ${text}`}
      </CcEyebrow>
    </Link>
  );
}
